import { Input, InputProps, SelectOptionType } from '@bp/ui-components';
import { getIn, useField, useFormikContext } from 'formik';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ClassesFormType } from '../types/ClassesTypes';

type ClassesFormNameFieldProps = {
  showGrade: boolean;
  longName?: boolean;
  gradeGroupsOptions: SelectOptionType[];
} & InputProps;

export const ClassesFormNameField = ({
  showGrade,
  longName,
  gradeGroupsOptions,
  ...inputProps
}: ClassesFormNameFieldProps) => {
  const { t } = useTranslation();

  const {
    values: { gradeGroupUuid, grade },
    touched,
    setFieldValue,
    initialValues,
    validateField,
  } = useFormikContext<ClassesFormType>();

  const [field] = useField(inputProps.name);

  useEffect(() => {
    const fieldIsTouched = getIn(touched, inputProps.name);
    const initialFieldValue = getIn(initialValues, inputProps.name);
    const gradeName = gradeGroupsOptions.find((g) => g.value === gradeGroupUuid);

    if (!fieldIsTouched && initialFieldValue === '') {
      const gradeGradeGroupShort =
        gradeName?.label && gradeName.value !== null ? `${grade}${gradeName?.label}` : `${grade}`;

      const gradeGradeGroupLong =
        gradeName?.label && gradeName.value !== null
          ? `${grade}. ${t('classes.title', { count: 1 })} ${gradeName?.label}`
          : `${grade}. ${t('classes.title', { count: 1 })}`;

      const computedName = longName
        ? showGrade
          ? gradeGradeGroupLong
          : `${t('classes.title', { count: 1 })}`
        : showGrade
          ? gradeGradeGroupShort
          : ``;

      setFieldValue(inputProps.name, computedName).then(() => {
        validateField(inputProps.name);
      });
    }
  }, [
    grade,
    gradeGroupUuid,
    gradeGroupsOptions,
    initialValues,
    inputProps.name,
    longName,
    setFieldValue,
    showGrade,
    t,
    touched,
    validateField,
  ]);

  return <Input {...inputProps} {...field} />;
};
